import './PaymentsResume.component.scss';

import React, { useEffect, useState } from 'react';
import { FormattedDate, FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import { EBankKeys, IBankPaymentResume } from '../../../domain/bank.interface';
import {
  loadBankPaymentsResume,
  resetBank,
} from '../../../store/bank/bank.actions';
import { makeSelectPaymentsResume } from '../../../store/bank/bank.selectors';
import { getDateLabel } from '../../../utils/dateFormatters';
import { formatNumberToCurrency } from '../../../utils/FormNormalizers';
import {
  NavbarComponent,
  NavigationMenuComponent,
} from '../../organisms/organisms.index';

function PaymentsResumeItem(props: IBankPaymentResume) {
  const { pendingPayment, amount, date, paidFor } = props;

  return (
    <FormattedDate value={date} year='numeric' month='long' day='2-digit'>
      {(formattedDate: any) => (
        <div className='minicard'>
          <div className='minicard-info'>
            <h6>{pendingPayment.group.name}</h6>
            {!!paidFor && (
              <p>
                <FormattedMessage id='pages.payment-resume.paidfor' />
                {': '}
                <span className='text-primary'>{paidFor}</span>
              </p>
            )}
            <p>{formattedDate}</p>
          </div>
          <div className='minicard-right-text'>
            <p className='text-danger'>- {formatNumberToCurrency(amount)}</p>
          </div>
        </div>
      )}
    </FormattedDate>
  );
}

export function PaymentsResumeComponent(props: any) {
  const dispatch = useDispatch();
  const paymentsResume: IBankPaymentResume[] = useSelector(
    makeSelectPaymentsResume(),
  );
  const [paymentsResumeList, setPaymentsResumeList] = useState<any>({});
  const [paymentsResumeListKeys, setPaymentsResumeListKeys] = useState<any>([]);

  function generatePaymentsResumeList() {
    if (!paymentsResume || !paymentsResume.length) {
      return;
    }
    let list: any = {};
    paymentsResume
      .sort((elA: IBankPaymentResume, elB: IBankPaymentResume) => {
        const a = new Date(Date.parse(elA.date));
        const b = new Date(Date.parse(elB.date));
        return a > b ? -1 : a < b ? 1 : 0;
      })
      // eslint-disable-next-line
      .map((el: IBankPaymentResume) => {
        const splittedDate = el.date.split('-');
        const key = `${splittedDate[0]}/${splittedDate[1]}`;
        if (!list.hasOwnProperty(key)) {
          list = { ...list, [key]: [] };
        }
        list[key] = [...list[key], el];
      });
    setPaymentsResumeList(list);
    setPaymentsResumeListKeys(Object.keys(list));
  }

  useEffect(() => {
    dispatch(loadBankPaymentsResume());
    return () => {
      dispatch(resetBank(EBankKeys.paymentsResume));
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    generatePaymentsResumeList();
    // eslint-disable-next-line
  }, [paymentsResume]);

  return (
    <div className='page-container'>
      <NavbarComponent />
      <NavigationMenuComponent {...props} />
      <div className='page-title'>
        <h4>
          <FormattedMessage id='pages.my-bank.main.link_paymentsResume' />
        </h4>
      </div>
      <div className='content-wrapper'>
        {!!paymentsResume && !!paymentsResume.length ? (
          paymentsResumeListKeys.map((el: string, idx: number) => {
            const label = getDateLabel(el);
            return (
              <div className='mb-5' key={idx}>
                <FormattedDate value={label} year='numeric' month='long'>
                  {(formattedDate: any) => (
                    <div>
                      <h6 className='subtitle'>{formattedDate}</h6>
                      {paymentsResumeList[el].map(
                        (pr: IBankPaymentResume, elIdx: number) => (
                          <PaymentsResumeItem key={`item-${elIdx}`} {...pr} />
                        ),
                      )}
                    </div>
                  )}
                </FormattedDate>
              </div>
            );
          })
        ) : (
          <p className='text-primary'>
            <FormattedMessage id='pages.my-bank.no_data' />
          </p>
        )}
      </div>
    </div>
  );
}
